import { TypeAsserter } from '@attain-apps/type-guards'

import * as core from '../../core'

import type { Functionalization } from './functionalization'
import type { Record } from './record'

export type ServiceCenter = core.common.Identified<ServiceCenter.Id> &
  core.common.Named &
  core.common.Coded & {
    functionalizations: Functionalization[]
    assignedSpaceIds: Record.Id[]
  }

export namespace ServiceCenter {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  /**
   * Information needed to create a {@link ServiceCenter}
   */
  export type Input = Omit<ServiceCenter, 'id' | 'code' | 'assignedSpaceIds'>

  export type Create = Input
  export type Update = Input
}
